export const API_URL = process.env.REACT_APP_API_URL;
export const pageSizes = process.env.REACT_APP_PAGE_SIZES.split(',').map(Number);
export const awsCdnPrefix = process.env.REACT_APP_AWS_CDN_PREFIX;
export const userPicturePrefix = process.env.REACT_APP_USER_PICTURE_PREFIX;
export const customerPicturePrefix = process.env.REACT_APP_CUSTOMER_PICTURE_PREFIX;
export const userDefaultPicture = process.env.REACT_APP_USER_DEFAULT_PICTURE;
export const customerDefaultPicture = process.env.REACT_APP_CUSTOMER_DEFAULT_PICTURE;
export const MAPS_API_KEY = process.env.REACT_APP_MAPS_API_KEY;
export const GEOCODING_API_KEY = process.env.REACT_APP_GEOCODING_API_KEY;
export const learnerTeacherIntroVideo = process.env.REACT_APP_LEARNER_TEACHER_INTRO_VIDEO;
export const userManualUrl = process.env.REACT_APP_USER_MANUAL_URL;
export const learnerManualUrl = process.env.REACT_APP_LEARNER_MANUAL_URL;
export const frontendKey = process.env.REACT_APP_FRONTEND_KEY;
export const contactUsPageVideo = process.env.REACT_APP_CONTACT_US_PAGE_VIDEO;
